import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { DISTRIBUTION_JOBS_API } from "./apiRoutes";
import axiosAuth from "../axiosAuth";

interface mutateProps {
  jobId: string
  communityId: string;
}

const mutateUpdateJobStatus = async ({ jobId, communityId }: mutateProps) => {
  return await axiosAuth.patch(
    `${DISTRIBUTION_JOBS_API(communityId)}/${jobId}/toggle-active`,
  );
};

const useUpdateJobStatusMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    mutateProps,
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateUpdateJobStatus,
    ...queryParams,
  });

export default useUpdateJobStatusMutation;
